<div #content class="p-without-margin" [@slideMoreLess]="animationState" [attr.data-testid]="uid">
    <ng-content select="[text]"></ng-content>
</div>
